
import "@/sass/globals.scss";

import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { uiStore } from "@/store/store";
import Notifications from "@/components/Notifications/Notifications.vue";
import Builder from "@/Builder.vue";
import BrowseMode from "@/BrowseMode.vue";

@Component({
  components: {
    BrowseMode,
    Builder,
    Notifications
  }
})
export default class App extends Vue {
  beforeMount() {
    uiStore.setMode(window.Breakdance.initialMode);
  }

  get isBrowseModeEnabled() {
    return uiStore.mode === "browse";
  }

  get useDarkMode() {
    return (
      // uiStore reference is probably necessary to make Vue re-run the watcher
      uiStore.settings.theme === "dark"
    );
  }

  get classList() {
    return { "breakdance-dark-mode": this.useDarkMode };
  }

  @Watch("useDarkMode", {
    immediate: true
  })
  darkModeWatcher(useDarkMode: boolean) {
    // @ts-ignore
    this.$vuetify.theme.dark = useDarkMode;
  }
}
